import { Dispatch, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';

import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { catalogGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { makeGetCatalogSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { coreSetOptionName } from 'CorePackage/MainModule/actions/coreActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCoreIsDeepLoading, getCoreOptionName } from 'CorePackage/MainModule/selectors/coreSelectors';

import { ISelectInputFieldProps, SelectInputField } from './SelectInputField';
import { ISelectOption } from './SelectInput';

type ISelectOptions = ISelectOption<string | number>[] | undefined;

interface ISelectInputFieldAutoOptionsProps {
  optionName: CommonCatalogsNamesEnum;
  transformFunc?: (item: ISelectOptions) => ISelectOptions;
  warning?: string;
}

interface ISelectInputFieldAutoOptionsStoreProps {
  optionsByName: ISelectOptions;
  isDeepLoading: boolean;
}

const SelectInputFieldAutoOptionsWithoutStore = ({
  optionName,
  optionsByName,
  isDeepLoading,
  transformFunc,
  warning,
  ...rest
}: ISelectInputFieldAutoOptionsProps & ISelectInputFieldAutoOptionsStoreProps & ISelectInputFieldProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleOpenMenuList = useCallback(() => {
    dispatch(coreSetOptionName(optionName));
    dispatch(catalogGet(optionName, true));
  }, [dispatch, optionName]);

  const currentOptions = transformFunc ? transformFunc(optionsByName) : optionsByName;

  return (
    <SelectInputField
      {...rest}
      onOpen={handleOpenMenuList}
      options={currentOptions}
      isDeepLoading={isDeepLoading}
      warning={warning}
    />
  );
};

const mapStateToProps = (state: IRootState): ISelectInputFieldAutoOptionsStoreProps => {
  const optionName = getCoreOptionName(state);
  const currentOptionSelector = optionName ? makeGetCatalogSelectOptions(optionName) : undefined;

  return {
    optionsByName: currentOptionSelector ? currentOptionSelector(state) : undefined,
    isDeepLoading: getCoreIsDeepLoading(state),
  };
};

export const SelectInputFieldAutoOptions = connect(mapStateToProps)(SelectInputFieldAutoOptionsWithoutStore);
